export default "__VITE_ASSET__NxXpsk9f__"